<template>
  <div class="feedback-success-page">
    <div class="page-head">
      <van-icon name="arrow-left" class="back" @click="$router.back()"></van-icon>
      <div class="title">{{ $t("m.submitted_successfully") }}</div>
    </div>

    <div class="content">
      <div class="center-wrap">
        <div class="check-circle">
          <img :src="tick" class="check-icon" alt="tick" />
        </div>
        <div class="succ-title">{{ $t("m.submitted_successfully") }}</div>
        <div class="succ-desc">{{ $t("m.feedback_success_tip") }}</div>

        <van-button class="done-button" type="primary" @click="onDone">{{ $t("m.completed") }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import tick from '@/assets/img/tick.svg';
Vue.use(Button);
export default {
  name: 'feedbackSuccess',
  data() {
    return {
      tick
    };
  },
  methods: {
    onDone() {
      // go back to home or close view
      this.$router.push({ path: '/index' });
    },
    onRecord() {
      // go to feedback list - reuse asks page if appropriate
      this.$router.push({ path: '/asks' });
    }
  }
}
</script>

<style scoped>
.feedback-success-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.page-head {
  display:flex;
  align-items:center;
  padding: .2rem .3rem;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.page-head .title {
  flex:1;
  text-align:center;
  font-size:.36rem;
  font-weight:600;
}
.content {
  flex:1;
  display:flex;
  justify-content:center;
  background:#fff;
}
.center-wrap {
  text-align:center;
}
.check-circle {
  width:2.4rem;
  height:2.4rem;
  border-radius:50%;
  background: linear-gradient(90deg,#9259FE,#6365FF);
  display:flex;
  align-items:center;
  justify-content:center;
  margin: 0 auto 0.4rem;
}
.check-icon {
  color:#fff;
  font-size:1.2rem;
}
.succ-title {
  font-weight:700;
  margin-bottom: .12rem;
  font-size:.32rem;
}
.succ-desc {
  color:#9497A2;
  font-size:.22rem;
  margin-bottom: .6rem;
}
.done-button {
  width:3.2rem;
  height: .88rem;
  border-radius: .44rem;
  background: linear-gradient(90deg,#9259FE,#6365FF);
  color:#fff;
  border: none;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.record-link {
  color:#6365FF;
  margin-top:.3rem;
  font-size:.22rem;
  cursor:pointer;
}
.check-circle {
  width: 1.24rem;
  height: 1.24rem;
}

.center-wrap {
  margin-top: 1.2rem;
}  
</style>




// WEBPACK FOOTER //
// src/pages/feedbackSuccess.vue